<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    class="sidenav"
    fixedInViewport="true"
    #drawer
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) === false">
    <mat-toolbar>Menu</mat-toolbar>
    <mat-nav-list>
      <a
        mat-list-item
        routerLink="/">
        Audit Log
      </a>
      <a
        mat-list-item
        routerLink="/subscription">
        Subscriptions
      </a>
      <a
        mat-list-item
        routerLink="/link-shortener">
        Link Shortener
      </a>
      <a
        mat-list-item
        routerLink="/ml"
        *ngIf="(loggedUser$ | async)?.appMetaData?.authorization?.permissions?.includes('admin:ml:all')">
        ML
      </a>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar color="primary">
      <button
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        *ngIf="isHandset$ | async"
        (click)="drawer.toggle()">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <div class="w-100 d-flex justify-content-between">
        <div>
          <span>smarthead-admin</span>
        </div>
        <div
          id="logged-user"
          *ngIf="loggedUser$ | async">
          <span>{{ (loggedUser$ | async)?.email }} | </span>
          <span
            role="button"
            (click)="onLogoutButtonClick()">
            logout
          </span>
        </div>
      </div>
    </mat-toolbar>
    <!-- Add Content Here -->
    <div class="p-3">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
